import useLoadingText from '../../hooks/useLoadingText';
import useThread from '../../hooks/useThread';
import { parseBlockID } from '../../utils/parse';
import useItem from '../../hooks/useItem';
import { classnames } from '@/utils/functions';
import BaseMessage from '../Message/BaseMessage';
import Response from '../Message/Response';
import styles from './item.module.scss';

const Item = () => {
  const { status } = useThread();
  const { item: block, isLast } = useItem();
  const { id, prompt, response, queryDate, disliked } = block;
  const loadingText = useLoadingText(status);
  const isLoading =
    response.length === 0 && status === 'FETCHING' && loadingText;

  return (
    <div
      data-testid="thread-item"
      className={classnames(styles['item'], {
        [styles['disliked']]: disliked,
      })}
      id={parseBlockID(id)}
      data-loading={!!(isLast && (status == 'TYPING' || isLoading))}
    >
      <span data-testid="item-date" className={styles['item-date']}>
        {queryDate.toLocaleString()}
      </span>
      <BaseMessage author="USER">{prompt}</BaseMessage>
      {isLast && status === 'ERROR' ? (
        <div data-testid={`item-error`} className={styles['error-banner']}>
          <p>Sorry, I am unable to process your request at the moment.</p>
        </div>
      ) : !isLoading ? (
        <>
          <BaseMessage author="ASSISTANT">
            <Response />
          </BaseMessage>
        </>
      ) : (
        <BaseMessage author="ASSISTANT">{loadingText}</BaseMessage>
      )}
    </div>
  );
};

export default Item;
